import React, { useState } from "react";
import NavItem from "./navItem";
// import { useFetchUser } from '../../../utils/hooks/useFetchUser'
import styles from '../misc/item.module.scss'
import { useNavigate } from "react-router-dom"

const MENU_LIST = [
  { text: "Home", href: "/" },
  { text: "Features", href: "#features" },
  { text: "Docs", href: "/docs/quickstart" },
  { text: "Commands", href: "/docs/commands" },
];

const LOGIN_BUTTON = [{ text: "Login", href: "/login" }]

const Navbar = ({user, error, loading}: any) => {
  const [navActive, setNavActive] = useState(null);
  const [activeIdx, setActiveIdx] = useState(-1);
  const navigate = useNavigate()

  let user_url
  if (user && !error) user_url = `https://cdn.discordapp.com/avatars/${user.id}/${user.avatar}`

  return (
    <div style={{ position: 'sticky', zIndex: '30', top: '0' }}>
      <nav className={`nav`}>
        <a href={"/"}>
          <p style={{ display: 'flex', justifyContent: 'spaceBetween' }}>
            <div>
              <img src="/logo.svg" width="30" height="30" alt="Logo"/>
            </div>
            <div>
              <h1 className="logo" style={{ paddingLeft: '10px' }}>Dreamvast</h1>
            </div>
          </p>
        </a>
        <div
          onClick={() => setNavActive(!navActive as any)}
          className={`nav__menu-bar`}
        >
          <div></div>
          <div></div>
          <div></div>
        </div>
        <div className={`${navActive ? "active" : ""} nav__menu-list`}>
          {MENU_LIST.map((menu, idx) => (
            <div
              onClick={() => {
                setActiveIdx(idx);
                setNavActive(false as any)
              }}
              key={menu.text}
            >
              <NavItem active={activeIdx === idx} {...menu} />
            </div>
          ))}

          {
            user && !error ?
              <>
                <div className={'server_button'} onClick={() => navigate('/menu')}>
                  <h3>Server</h3>
                </div>

                <div key={user.id}>
                  <a href={'/user/@me'}>
                    <p style={{ display: 'flex', justifyContent: 'spaceBetween' }}>
                      <img
                        src={user_url}
                        height={40} 
                        width={40} 
                        className={styles.image} 
                        alt={user.username}
                        />
                    </p>
                  </a>
                </div>
              </> : 
              LOGIN_BUTTON.map((menu, idx) => (
                <div
                  onClick={() => {
                    setActiveIdx(idx);
                    setNavActive(false as any)
                  }}
                  key={menu.text}
                >
                  <NavItem active={activeIdx === idx} {...menu} />
                </div>
              ))
          }
        </div>
      </nav>
    </div>
  );
};

export default Navbar;